import { ChevronDown } from "lucide-react";
import { TokenOption } from "./types";
import { cn } from "@/lib/utils";
import { Select, SelectContent, SelectItem, SelectTrigger } from "@/components/ui/select";

interface TokenSelectProps {
  token: TokenOption;
  onTokenSelect?: (token: TokenOption) => void;
  availableTokens?: TokenOption[];
  className?: string;
  triggerClassName?: string;
}

export function TokenSelect({ token, onTokenSelect, availableTokens = [], className, triggerClassName }: TokenSelectProps) {
  const handleValueChange = (value: string) => {
    const selectedToken = availableTokens.find((t) => t.id === value);
    if (selectedToken && onTokenSelect) {
      onTokenSelect(selectedToken);
    }
  };

  return (
    <div className={className}>
      <Select onValueChange={handleValueChange} value={token.id} disabled={availableTokens.length === 0}>
        <SelectTrigger className={cn("min-w-[120px] border-0 shadow-none focus-visible:ring-0 focus-visible:ring-offset-0 p-4 h-auto", triggerClassName)}>
          <div className='flex items-center gap-2'>
            {token.icon}
            <span>{token.name}</span>
          </div>
          <ChevronDown className='h-4 w-4 opacity-50' />
        </SelectTrigger>
        <SelectContent align='end' className='min-w-[120px]'>
          {availableTokens.map((t) => (
            <SelectItem key={t.id} value={t.id} className='cursor-pointer'>
              <div className='flex items-center gap-2'>
                {t.icon}
                <span>{t.name}</span>
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
